import axios from "axios";
import { attachAuthInterceptor } from "./authInterceptor";

const uploadClient = axios.create({
  baseURL: import.meta.env.VITE_UPLOAD_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(uploadClient);

export default uploadClient;
